import { createSlice } from '@reduxjs/toolkit';
import { mergeReduxStateData } from 'library/helpers/reduxHelpers';

const initialState = {
	data: {},
	timeStamp: null,
	loading: false,
	searchable: true,

	// ✅ Loading states
	loadingAddMembersTeam: false,

	// ✅ Completed states
	completeAddMembersTeam: false,
	completeAddTeam: false,
	teamsLoadingComplete: false,
	teamMembersLoading: false,
	addTeamLoading: false,
	updateTeamLoading: false,
	deleteTeamLoading: false,
	addTeamMemberLoading: false,
	deleteTeamMemberLoading: false,
	error: null
};

const teamsSlice = createSlice({
	name: 'teams',
	initialState,
	reducers: {
		// Load Teams
		loadTeams(state) {
			state.loading = true;
			state.error = null;
		},
		loadTeamsSuccess(state, action) {
			state.timeStamp = Date.now();
			state.loading = false;
			const { orgID, data } = action.payload;
			const oldTeamsData = state.data[orgID] || [];
			state.data[orgID] = mergeReduxStateData(oldTeamsData, data, 'teamID');
			state.teamsLoadingComplete = true;
		},
		loadTeamsError(state, action) {
			state.error = action.payload;
			state.loading = false;
		},
		// Load All Teams with Members
		loadAllTeamsMembers(state) {
			state.loading = true;
			state.error = null;
		},
		loadAllTeamsMembersSuccess(state, action) {
			const { orgID, data } = action.payload;

			//  data is an object with teamID as the key and an array of personIDs as the value
			//  we need to add the personIDs to the state.data[orgID][teamID].members
			state.data[orgID] = state.data[orgID].map((team) => {
				const members = data[team.teamID] || [];
				return { ...team, members };
			});
			// state.loading = false;
		},
		loadAllTeamsMembersError(state, action) {
			state.error = action.payload;
			state.loading = false;
		},

		// Load Team Members
		loadTeamMembers(state) {
			state.teamMembersLoading = true;
			state.error = null;
		},
		loadTeamMembersSuccess(state, action) {
			const { orgID, teamID, data } = action.payload;
			state.data[orgID] = state.data[orgID].map((team) =>
				team.teamID === teamID ? { ...team, members: data } : team
			);
			state.teamMembersLoading = false;
		},
		loadTeamMembersError(state, action) {
			state.error = action.payload;
			state.teamMembersLoading = false;
		},

		// Add Team Member
		addTeamMember(state) {
			state.loadingAddMembersTeam = true;
			state.completeAddMembersTeam = false;
			state.error = null;
		},
		addTeamMemberSuccess(state) {
			state.loadingAddMembersTeam = false;
			state.completeAddMembersTeam = true;
		},
		addTeamMemberError(state, action) {
			state.error = action.payload;
			state.loadingAddMembersTeam = false;
			state.completeAddMembersTeam = false;
		},
		resetCompleteAddMembersTeam(state) {
			state.completeAddMembersTeam = false;
		},

		// Delete Team Member
		deleteTeamMember(state) {
			state.deleteTeamMemberLoading = true;
		},
		deleteTeamMemberSuccess(state) {
			state.deleteTeamMemberLoading = false;
		},
		deleteTeamMemberError(state, action) {
			state.error = action.payload;
			state.deleteTeamMemberLoading = false;
		},

		// Add Team
		addTeam(state) {
			state.addTeamLoading = true;
			state.completeAddTeam = false;
			state.error = null;
		},
		addTeamSuccess(state) {
			state.addTeamLoading = false;
			state.completeAddTeam = true;
		},
		addTeamError(state, action) {
			state.error = action.payload;
			state.addTeamLoading = false;
			state.completeAddTeam = false;
		},

		// Update Team
		updateTeam(state) {
			state.updateTeamLoading = true;
			state.error = null;
		},
		updateTeamSuccess(state) {
			state.updateTeamLoading = false;
		},
		updateTeamError(state, action) {
			state.error = action.payload;
			state.updateTeamLoading = false;
		},

		// Delete Team
		deleteTeam(state) {
			state.deleteTeamLoading = true;
			state.error = null;
		},
		deleteTeamSuccess(state) {
			state.deleteTeamLoading = false;
		},
		deleteTeamError(state, action) {
			state.error = action.payload;
			state.deleteTeamLoading = false;
		}
	},
	extraReducers: (builder) => {
		builder.addCase('auth/logout', () => initialState);
	}
});

// Export actions
export const teamsActions = teamsSlice.actions;

// Export reducer
export default teamsSlice.reducer;
